var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { checkIfSearchable } from 'ziphy-web-shared/basic/entities/notes/resources';
import { useDropdown } from 'ziphy-web-shared/basic/lib/functional';
import { $notes } from './Notes.store';
export function useSelectMacroDropdown({ $section, macrosList, onSelect, isTextBlock = false, }) {
    const { t } = useTranslation();
    const [macro, setMacro] = useState(null);
    const [triggerModal, setTriggerModal] = useState(0);
    const isMulti = useMemo(() => (macro === null || macro === void 0 ? void 0 : macro.type) === 'resources', [macro]);
    const dropdown = useDropdown(useMemo(() => {
        return macrosList.map(([type, items]) => ({
            id: type,
            label: t(`label.macros_group.${type}`),
            items: items.map((macro) => {
                return {
                    id: macro.id,
                    label: macro.name,
                    // // @ts-ignore
                    // description: [macro.properties?.resourceType, macro.properties?.element]
                    //   .filter(Boolean)
                    //   .join(' - '),
                    extra: { aliases: macro.aliases || [], type: macro.type },
                    onClick: () => __awaiter(this, void 0, void 0, function* () {
                        var _a, _b;
                        const isUniqueAndUsed = macro.unique &&
                            (!isTextBlock ? macro.type === 'block' || macro.type === 'template' : true) &&
                            $section.usedUniqueBlocks.has(macro.id);
                        if (isUniqueAndUsed) {
                            $notes.highlightBlock(macro.id, 'existing');
                            (_a = dropdown.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.setIsOpen(false);
                            return;
                        }
                        if (macro.type === 'resource' || macro.type === 'resources') {
                            setMacro(macro);
                            if (!checkIfSearchable(macro.properties.searchPreference)) {
                                setTriggerModal((x) => x + 1);
                            }
                        }
                        else {
                            yield onSelect(macro.id);
                            (_b = dropdown.dropdownRef.current) === null || _b === void 0 ? void 0 : _b.setIsOpen(false);
                        }
                    }),
                };
            }),
        }));
    }, [macrosList]), { searchValuesPaths: ['extra.aliases'] });
    return { dropdown, macro, setMacro, isMulti, triggerModal };
}
export function useInitialSelected(macro) {
    return useMemo(() => {
        if ((macro === null || macro === void 0 ? void 0 : macro.unique) && (macro.type === 'resource' || macro.type === 'resources')) {
            const block = $notes.uniqueBlocksData.get(macro.id);
            if (block === null || block === void 0 ? void 0 : block.data) {
                if (macro.type === 'resources') {
                    return Object.keys(block.data);
                }
                else {
                    return Object.keys(block.data)[0];
                }
            }
        }
    }, [macro]);
}
